import { Button } from '@cian/ui-kit';
import { FC } from 'react';

import styles from './ExpandCollapseAdornment.css';

interface IExpandCollapseAdornmentProps {
  isExpanded: boolean;
}

export const ExpandCollapseAdornment: FC<IExpandCollapseAdornmentProps> = props => {
  if (props.isExpanded) {
    return (
      <div className={styles['button']}>
        <Button theme="fill_secondary" size="XS">
          Свернуть
        </Button>
      </div>
    );
  }

  return (
    <div className={styles['button--with-dots']} data-testid="show-more-button">
      <Button theme="fill_secondary" size="XS">
        •••
      </Button>
    </div>
  );
};
